/* ============================================================
   pm-blog-post-v2.js
   Progress bar + FAQ accordion + reveal-on-scroll animations
   for the blog-post-v2 article template.
   ============================================================ */
(function(){
  function init(){
    // Progress bar — width tracks scroll position within .art-content
    var progressFill = document.querySelector('.bpv2-progress .fill');
    var article = document.querySelector('.art-content');
    if (progressFill && article) {
      function updateProgress(){
        var rect = article.getBoundingClientRect();
        var start = rect.top + window.scrollY - 200;
        var end = start + article.offsetHeight;
        var scrolled = window.scrollY;
        var pct = Math.max(0, Math.min(100, ((scrolled - start) / (end - start)) * 100));
        progressFill.style.width = pct + '%';
      }
      window.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    }

    // Reveal on scroll
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.bpv2 [data-reveal]').forEach(function(el){ io.observe(el); });
    } else {
      // Older browsers — just show everything
      document.querySelectorAll('.bpv2 [data-reveal]').forEach(function(el){ el.classList.add('is-in'); });
    }

    // FAQ accordion
    var faqRows = document.querySelectorAll('.bpv2-faq .qrow');
    faqRows.forEach(function(row){
      row.addEventListener('click', function(){
        faqRows.forEach(function(o){ if (o !== row) o.classList.remove('is-open'); });
        row.classList.toggle('is-open');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
